export const UserPermission = {
  SuperAdmin: "SUPER_ADMIN",
  AccountAdmin: "ACCOUNT_ADMIN",
  Clinician: "CLINICIAN",
  GuestClinician: "GUEST"
};
export const UserPermissions = {
  All: [
    UserPermission.SuperAdmin,
    UserPermission.AccountAdmin,
    UserPermission.Clinician,
    UserPermission.GuestClinician
  ],
  AllExcludeSuper: [
    UserPermission.AccountAdmin,
    UserPermission.Clinician,
    UserPermission.GuestClinician
  ],
  AccountAdmin: [UserPermission.SuperAdmin, UserPermission.AccountAdmin],
  Internal: [
    UserPermission.SuperAdmin,
    UserPermission.AccountAdmin,
    UserPermission.Clinician
  ],
  Admin: [UserPermission.SuperAdmin]
};
export const TaskCategories = {
  INFO: "INFO",
  EXERCISE: "EXERCISE",
  FORM: "FORM",
  EMAIL: "EMAIL"
};

export const Pages = {
  Accounts: "Accounts"
};



// WEBPACK FOOTER //
// ./src/config/index.js